import axios, { AxiosError } from 'axios';
import { PropertySelections } from './types';
import {
    getParticleIdsInTree,
    applyAttachmentSelections,
    ResolveFurnitureChoiceTree,
} from './furniture';
import * as CoreStore from '../../store/core';
import { AppError } from '../../data/appError';
import { AnyAction, Dispatch } from 'redux';
import * as ConfigurationActions from '../../store/actions/configuration';

export type ConfigurationBasket = {
    products: Array<{ productId: string; quantity: number }>;
    price: number;
};

export async function getBasketForParticles(
    gluonUrl: string,
    tenantId: string,
    furnitureParticles: string[],
    dispatch: Dispatch<AnyAction>,
    disableErrorHandling: boolean,
): Promise<ConfigurationBasket> {
    return axios
        .post(`${gluonUrl}/api/v1/${tenantId}/basket`, {
            particles: furnitureParticles,
        })
        .then(res => {
            return {
                products: res.data.products,
                price: res.data.price,
            };
        })
        .catch((error: AxiosError) => {
            if (!disableErrorHandling) {
                dispatch(CoreStore.error(AppError.CONFIGURATION_DATA_LOAD_FAILED));
                dispatch(
                    ConfigurationActions.errorAction({
                        reason: error.response?.data.message,
                        type: 'catch all',
                    }),
                );
            }
            return { products: [], price: 0 } as ConfigurationBasket;
        });
}
export async function getPrice(
    resolveFurnitureChoiceTree: ResolveFurnitureChoiceTree,
    getBasketForParticles: (furnitureParticles: string[]) => Promise<ConfigurationBasket>,
    selections: PropertySelections,
    attachmentProposals: Record<string, string>,
) {
    const furnitureChoices = await resolveFurnitureChoiceTree(selections);

    if (!furnitureChoices) {
        return null;
    }

    const { furnitureChoiceTree, attachmentOptions } = furnitureChoices;

    const { furnitureTree } = applyAttachmentSelections(
        attachmentOptions,
        attachmentProposals,
        furnitureChoiceTree,
    );
    const furnitureParticles = getParticleIdsInTree(furnitureTree);

    const basket = await getBasketForParticles(furnitureParticles);

    return basket.price;
}
